import Http from "./http";

export const triggerComplianceCampaignAPI = (payload) => {
  return Http.post("admin/campaign/trigger-compliance", payload);
};
